module.exports = __webpack_public_path__ + "static/media/logo_login.fca0b671.png";